<template>
  <div class="mod-coupon passenger-coupon">
    <div class="cell-header">
      <h3>
        优惠券
        <a-checkbox @change="onCheck" :checked="show" :disabled="!valid.valid">使用优惠券
          <router-link class="links" v-for="item in couponAgreement" :to="item.url" :key="item.url" target="_blank">{{ item.name }}</router-link>
        </a-checkbox>
        <!-- NOTE: JD - 不需要提示 -->
        <span class="coupon-warn" v-show="valid.msg" v-if="airline !== 'JD'"><a-icon type="info-circle" /> {{ valid.msg }} </span>
      </h3>
    </div>
    <div class="cell-body" v-if="show">
      <a-spin :spinning="loading">
        <div v-if="!loading && !coupons.length" class="empty">
          暂时没有可使用的优惠券。
        </div>
        <coupon-group
          v-else
          :options="coupons"
          :selected="selected"
          @change="onCouponChange"
        >
        </coupon-group>
      </a-spin>
    </div>
  </div>
</template>

<script>
import CouponGroup from '@/components/coupon/coupon-group'
const airline = window.__MICRO_ROOT__?.airline

export default {
  data () {
    return {
      show: false,
      selectedCoupons: [],
      airline
    }
  },
  props: {
    coupons: Array,
    valid: Object,
    loading: Boolean,
    selected: String,
    couponAgreement: Array
  },
  watch: {
    valid (value) {
      if (!value.valid) {
        this.show = false
      }
    }
  },
  methods: {
    onCheck () {
      this.show = !this.show

      if (!this.show) {
        this.selectedCoupons = []
        this.$emit('change', this.selectedCoupons)
      } else {
        this.$emit('query', this.show)
      }

      this.$emit('visible', this.show)
    },
    onCouponChange (value) {
      this.selectedCoupons = value
      this.$emit('change', this.selectedCoupons)
    }
  },
  components: {
    CouponGroup
  }
}
</script>

<style lang="less">
  .mod-coupon.passenger-coupon {
    margin-top: 0px;

    .cell-header {
      line-height: 30px;
      font-size: 24px;

      .ant-checkbox-wrapper {
        margin-left: 26px;
      }
    }

    .coupon-warn {
      color: @primary-color;
      font-size: 14px;
    }

    .cell-body {
      .action {
        display: inline-block;
        padding-top: 16px;
        vertical-align: top;
      }

      .empty {
        text-align: center;
        color: #888;
        font-size: 14px;
        margin-top: 15px;
      }
    }

    .tip {
      margin-top: 20px;
    }

    .coupon-content {
      overflow: hidden;
    }
  }
</style>
